export { GuildBlackFridayHero } from './GuildBlackFridayHero'
